"use strict";

gc.gis.factory = gc.gis.factory || {};

gc.gis.factory.ObjectFactory = function()
{
};

/**
 * Erzeugt eine Kartenimplementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {gc.gis.map.GCMapView} holder Zugehörige Kartenwrapper-Instanz
 * @param {Object} options Aufrufoptionen (siehe auch {@link gc.gis.map.GCAbstractMap})
 * @return {gc.gis.map.GCAbstractMap}
 */
gc.gis.factory.ObjectFactory.prototype.createMap = gc.gis.abstractMethod;

/**
 * Erzeugt eine Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} geometry gewrappte Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCGeometry}
 */
gc.gis.factory.ObjectFactory.prototype.createGeometry = gc.gis.abstractMethod;

/**
 * Erzeugt eine Punkt-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_point] gewrappte Punkt-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCPoint}
 */
gc.gis.factory.ObjectFactory.prototype.createPoint = gc.gis.abstractMethod;

/**
 * Erzeugt eine Linien-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_linestring] gewrappte Linien-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCLineString}
 */
gc.gis.factory.ObjectFactory.prototype.createLineString = gc.gis.abstractMethod;

/**
 * Erzeugt eine Ring-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_linearring] gewrappte Ring-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCLinearRing}
 */
gc.gis.factory.ObjectFactory.prototype.createLinearRing = gc.gis.abstractMethod;

/**
 * Erzeugt eine Polygon-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_polygon] gewrappte Polygon-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCPolygon}
 */
gc.gis.factory.ObjectFactory.prototype.createPolygon = gc.gis.abstractMethod;

/**
 * Erzeugt eine Kreis-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_circle] gewrappte Kreis-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCCircle}
 */
gc.gis.factory.ObjectFactory.prototype.createCircle = gc.gis.abstractMethod;

/**
 * Erzeugt eine MultiPunkt-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_multipoint] gewrappte MultiPunkt-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCMultiPoint}
 */
gc.gis.factory.ObjectFactory.prototype.createMultiPoint = gc.gis.abstractMethod;

/**
 * Erzeugt eine MultiLinien-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_multiline] gewrappte MultiLinien-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCMultiLineString}
 */
gc.gis.factory.ObjectFactory.prototype.createMultiLineString = gc.gis.abstractMethod;

/**
 * Erzeugt eine MultiPolygon-Geometrie-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_multipolygon] gewrappte MultiPolygon-Geometrie-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCMultiPolygon}
 */
gc.gis.factory.ObjectFactory.prototype.createMultiPolygon = gc.gis.abstractMethod;

/**
 * Erzeugt eine Geometrie-Collection-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_collection] gewrappte Geometrie-Collection-Instanz gemäß Kartenbibliothek
 * @return {gc.gis.geom.GCGeometryCollection}
 */
gc.gis.factory.ObjectFactory.prototype.createGeometryCollection = gc.gis.abstractMethod;

/**
 * Erzeugt eine Feature-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {T} [opt_feature] gewrappte Feature-Instanz (optional) gemäß Kartenbibliothek
 * @return {gc.gis.feature.GCFeature}
 */
gc.gis.factory.ObjectFactory.prototype.createFeature = gc.gis.abstractMethod;

/**
 * Erzeugt eine Reader/Writer-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @return {gc.gis.format.GCFormat}
 */
gc.gis.factory.ObjectFactory.prototype.createFormat = gc.gis.abstractMethod;

/**
 * Erzeugt eine Geometrie-Prozessor-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @return {gc.gis.geom.GCGeometryProcessor}
 */
gc.gis.factory.ObjectFactory.prototype.createGeometryProcessor = gc.gis.abstractMethod;

/**
 * Erzeugt eine Tracking-Layer-Implementierung in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {gc.gis.map.GCAbstractMap} map Karte, welche die Objekte des Tracking-Layers darstellen soll
 * @return {gc.gis.layer.GCTrackingLayer}
 */
gc.gis.factory.ObjectFactory.prototype.createTrackingLayer = gc.gis.abstractMethod;

gc.gis.factory.ObjectFactory.prototype.createLayer = gc.gis.abstractMethod;

gc.gis.factory.ObjectFactory.prototype.createLayerGroup = gc.gis.abstractMethod;

gc.gis.factory.ObjectFactory.prototype.createVectorLayer = gc.gis.abstractMethod;

gc.gis.factory.ObjectFactory.prototype.createRasterLayer = gc.gis.abstractMethod;

/**
 * Erzeugt ein Objekt zur Verwaltung von Karteninteraktionen in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {gc.gis.map.GCMapView} map Karte, welche die Karteninteraction verarbeiten soll
 * @param {Object} [opt_options] optionale Aufrufoptionen
 * @param {gc.gis.style.GCAbstractStyle[]} [opt_options.drawingStyle] Darstellungseigenschaften während des Zeichnens
 * @param {gc.gis.style.GCAbstractStyle[]} [opt_options.finalStyle] Darstellungseigenschaften für fertige Objekte
 * @param {boolean} [opt_options.allowClearDrawingArea] Flag welches anzeigt, ob die Inhalte des korrespondierenden
 *      Tracking-Layers durch die Funktion "Zeichenfläche leeren", verändert werden dürfen
 * @param {string} [opt_options.textHelpTooltip] Text des Tooltips, der während des Zeichenvorganges eingeblendet wird
 * @param {boolean} [opt_options.freehand=false] Freihandzeichnen aktivieren
 * @return {gc.gis.map.GCMapDrawInteraction}
 */
gc.gis.factory.ObjectFactory.prototype.createMapDrawInteraction = gc.gis.abstractMethod;

/**
 * Erzeugt ein Objekt zur Verwaltung von Karteninteraktionen in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {gc.gis.map.GCMapView} map Karte, welche die Karteninteraction verarbeiten soll
 * @param {Object} [opt_options] optionale Aufrufoptionen
 * @return {gc.gis.map.GCMapTransformInteraction}
 */
gc.gis.factory.ObjectFactory.prototype.createMapTransformInteraction = gc.gis.abstractMethod;

/**
 * Erzeugt eine Provider, welcher den Zugriff auf einen WMS kapselt in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {gc.gis.util.GCRequestManager} requestManager
 * @param {gc.gis.map.GCAbstractMap} map
 * @return {gc.gis.map.GCAbstractWMSProvider}
 */
gc.gis.factory.ObjectFactory.prototype.createWMSProvider = gc.gis.abstractMethod;

/**
 * Erzeugt eine Provider, welcher den Zugriff auf einen WFS kapselt in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param {Object} options Optionen
 * @return {gc.gis.map.GCAbstractWFSProvider}
 */
gc.gis.factory.ObjectFactory.prototype.createWFSProvider = gc.gis.abstractMethod;

/**
 * Erzeugt eine Provider, welcher den Zugriff auf einen WMTS kapselt in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @param @param {gc.gis.util.GCRequestManager} requestManager
 * @return {gc.gis.map.GCAbstractWMTSProvider}
 */
gc.gis.factory.ObjectFactory.prototype.createWMTSProvider = gc.gis.abstractMethod;

/**
 * Erzeugt einen Füll-Style in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @return {gc.gis.style.GCFill}
 */
gc.gis.factory.ObjectFactory.prototype.createStyleFill = gc.gis.abstractMethod;

/**
 * Erzeugt einen Strichlierungs-Style in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @return {gc.gis.style.GCStroke}
 */
gc.gis.factory.ObjectFactory.prototype.createStyleStroke = gc.gis.abstractMethod;

/**
 * Erzeugt einen Kreis-Style in Abhängigkeit der Kartenbibliothek.
 *
 * @abstract
 * @return {gc.gis.style.GCCircle}
 */
gc.gis.factory.ObjectFactory.prototype.createStyleCircle = gc.gis.abstractMethod;
